<template lang="html">
	<div
	id="results"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section-container">
	<h1>Results</h1>
	<div class="metric-section">
		<img class="small" src="@/assets/img/metrics/1_.png">
		<img class="small" src="@/assets/img/metrics/2_.png">
		<img src="@/assets/img/metrics/3.png">
		<img src="@/assets/img/metrics/4.png">
	</div>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	margin-bottom: 300px;
	h1 {
		font-family: $heading-font;
		color:white;
		text-decoration: underline;
		font-size:60px;
		text-transform: uppercase;
		font-weight: 900;
		margin-top:50px;
	}
	.metric-section {
		display:flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.small {
			width: 40%;
		}
		img {
			width: 80%;
			padding: 30px;
		}
	}
}
    
</style>